"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var difference = require("lodash/difference");
var omit = require("lodash/omit");
var prop_types_1 = require("prop-types");
var React = require("react");
var recompose_1 = require("recompose");
var styled_components_1 = require("styled-components");
var styled_system_1 = require("styled-system");
var tooltips_1 = require("./tooltips");
var tooltip = new tooltips_1.Tooltips();
var prop = prop_types_1.oneOfType([prop_types_1.number, prop_types_1.string, prop_types_1.arrayOf(prop_types_1.oneOfType([prop_types_1.number, prop_types_1.string]))]);
var propTypes = {
    width: prop,
    fontSize: prop,
    color: prop,
    bg: prop,
    backgroundColor: prop,
    m: prop,
    mt: prop,
    mr: prop,
    mb: prop,
    ml: prop,
    mx: prop,
    my: prop,
    p: prop,
    pt: prop,
    pr: prop,
    pb: prop,
    pl: prop,
    px: prop,
    py: prop,
};
var styledSystemProps = Object.keys(propTypes);
var filterStyledSystemProps = function (passthroughProps) { return function (Base) {
    return React.forwardRef(function (props, ref) {
        var nextProps = omit(props, difference(styledSystemProps, passthroughProps));
        return React.createElement(Base, __assign({}, nextProps, { ref: ref }));
    });
}; };
exports.withStyledSystem = function (child) {
    var Base = styled_components_1.default(child)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t\t", "\n\t\t", "\n\t\t", "\n\t\t", "\n\t"], ["\n\t\t", "\n\t\t", "\n\t\t", "\n\t\t", "\n\t"])), styled_system_1.space, styled_system_1.width, styled_system_1.fontSize, styled_system_1.color);
    Base.displayName = recompose_1.getDisplayName(child);
    Base.propTypes = propTypes;
    return React.forwardRef(function (props, ref) {
        return React.createElement(Base, __assign({}, props, { ref: ref }));
    });
};
exports.withTooltip = function (Base) {
    return React.forwardRef(function (_a, ref) {
        var props = __rest(_a, []);
        if (props.tooltip) {
            props = tooltip.bindProps(props);
        }
        delete props.tooltip;
        return React.createElement(Base, __assign({}, props, { ref: ref }));
    });
};
function asRendition(component, additionalEnhancers, passthroughProps) {
    if (additionalEnhancers === void 0) { additionalEnhancers = []; }
    if (passthroughProps === void 0) { passthroughProps = []; }
    return recompose_1.compose.apply(void 0, [styled_components_1.withTheme].concat((additionalEnhancers || []), [exports.withTooltip,
        exports.withStyledSystem,
        filterStyledSystemProps(passthroughProps)]))(component);
}
exports.default = asRendition;
var templateObject_1;



//////////////////
// WEBPACK FOOTER
// /Users/dnlytras/.npm/_npx/11246/lib/node_modules/landr/theme/node_modules/rendition/dist/asRendition.js
// module id = 8
// module chunks = 2